import { render } from "./CreateOrUpdateTariffDetailModal.vue?vue&type=template&id=55be628b"
import script from "./CreateOrUpdateTariffDetailModal.vue?vue&type=script&lang=js"
export * from "./CreateOrUpdateTariffDetailModal.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__